import axios from 'axios'

const server = axios.create({
    baseURL: '/vscenter/apicore2/api/v1/',
    timeout: 30000
})

// request 拦截
server.interceptors.request.use(
    config => {
        // do something
        return config
    },
    error => {
        return error
    }
);

// response 拦截
server.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return error
    }
);

export default server



// WEBPACK FOOTER //
// ./src/api/index.js